/* global axios */

export const loadSubscriptionManagement = (
  accountId,
  {
    invoicePage = 1,
    invoicePageSize = 10,
    planPage = 1,
    planPageSize = 10,
    planQuery = '',
  } = {}
) =>
  axios.get(`/api/v1/accounts/${accountId}/subscription_management`, {
    params: {
      invoice_page: invoicePage,
      invoice_page_size: invoicePageSize,
      plan_page: planPage,
      plan_page_size: planPageSize,
      plan_q: planQuery,
    },
  });

export const mutateSubscription = (accountId, operation, planId = '') =>
  axios.post(`/api/v1/accounts/${accountId}/subscription_management/action`, {
    operation,
    ...(planId ? { plan_id: planId } : {}),
  });

export const syncSubscriptionPayment = (
  accountId,
  paymentId = '',
  invoiceId = ''
) =>
  axios.post(`/api/v1/accounts/${accountId}/subscription_management/action`, {
    operation: 'sync_payment',
    ...(paymentId ? { payment_id: paymentId } : {}),
    ...(invoiceId ? { invoice_id: invoiceId } : {}),
  });

export const requestSubscriptionRenewal = accountId =>
  axios.post(`/api/v1/accounts/${accountId}/subscription_renewal`);
